import { constants } from "../../../constants";

export default class GameJackpotEnd {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default(data){
        this.gb.emitters.emit.web.gameJackpotEnd(data)
    }

    exposeEvent(){
        let event = {}

        switch (this.gb.gameProviderProtocol){
            case constants.OAK:
                event["bigwin_finish"] = this._default;
                break;
            case constants.T4B:
                event["game.jackpot.ended"] = this._default;
                break;
        }
        return event
    }

}